<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="[
        'Tipo Bem',
        'Subtipo Bem Imov.',
        'Subtipo Bem Móvel',
        'Bem Imóvel',
        'Bem Móvel',
        'Quantidade Bem',
        'Porcentagem Propriedade',
        'Valor Participação Bem',
        'Área Total Imov.'
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad"
    >
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.tipoBem ? obj.tipoBem : '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.subtipoBemImovel ? obj.subtipoBemImovel : '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.subtipoBemMovel ? obj.subtipoBemMovel : '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.bemImovel ? obj.bemImovel : '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.bemMovel ? obj.bemMovel : '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.quantidadeBem ? obj.quantidadeBem : '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.porcentagemPropriedade ? obj.porcentagemPropriedade + '%' : '-'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valorParticipacaoBem
              ? formatValue(obj.valorParticipacaoBem)
              : '-'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.areaTotalImovel ? obj.areaTotalImovel : '-'"
        />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import PatrimonyRepository from '@/shared/http/repositories/business/patrimony.js'

import Tools from '@/components/tools/Tools.js'

export default {
  name: 'ContaPoupanca',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadBensAssociado(this.document)
      }
    },
    onLoadBensAssociado (document) {
      loading.push()
      this.document = document
      PatrimonyRepository.Search(
        document,
        this.$refs.tableGrid.pagingLimit,
        this.$refs.tableGrid.pagingIndex
      )
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/BensAssociado.vue